import React from "react";
import EmployeeNavbar from "./EmployeeNavbar";

function EmployeeHome() {
    
    return(
        <>
        <EmployeeNavbar />
        <div className="card" style={{backgroundColor:'gainsboro',position:'relative',top:'50px'}}>
            <h2 >Employee Home</h2>
        </div>
        </>
    );
}
export default EmployeeHome;